import React, { useEffect } from "react";

import WelcomeSection from '../../shared/components/WelcomeSection/WelcomeSection';
import NavegationInfo from '../../shared/components/NavegationInfo/NavegationInfo';
import ProductDescription from '../../shared/components/ProductDescription/ProductDescription';
import SectionInfo from '../../shared/components/SectionInfo/SectionInfo';
import Benefits from "../components/Benefits/Benefits";
import Faq from '../components/Faq/Faq';

import aboutUsBannerImg from '../../utils/assets/aboutUs/know-about-us.png';
import vitualCallImg from '../../utils/assets/aboutUs/virtual-call.png';


const AboutUs = props => {

   useEffect(()=>{
      window.scroll(0,0);
  },[])

    const bannerSectionInfo =
     {
        cardTitle: "Make sure your best friend gets everything he needs",
        cardButtonText: "Join us",
        lengendBackground: aboutUsBannerImg,
        cardOffer : [
         {       
             subscriptionType: "OUR OFFER",
             subscriptionPrice: "36.72",
             subscriptionTrialInfo: "Trial now for 30 days at ",
             subscriptionTrialPrice : "3.29",
             subscriptionDescription: "Monthly",
             subscriptionButtonText: "Buy"
         }, 
         {
             title : "Are you ready to rest easy knowing your pet has a vet available 24/7?",
         }
      ]
     }

     const productDescription = {
        title : "Find out more about who we are",
        img : vitualCallImg

     }
          
    return(
        <React.Fragment>
           <WelcomeSection props={bannerSectionInfo}/>
           <NavegationInfo page="About us"/>
           <ProductDescription props={productDescription} />
           <SectionInfo title = "Benefits" backgroundColor="#F2D479" textColor= "#B20918"/>
           <Benefits/>
           <Faq/>
        </React.Fragment>
    );
};

export default AboutUs;